export default __webpack_public_path__ + "e816148102256960288eaf6f0a2792a0.svg";